const config = {
  version: '2.1.1',
  type: 'js'
};

export default config;


/** WEBPACK FOOTER **
 ** ./src/config.ts
 **/